import { BaseEntity } from '../../../xform-compat';
import { CompanyBasic } from '../company/company-basic.model';
import { Person } from '../person.model';
import { TradeRestriction } from './trade-restriction.model';
import { BoardSeatRepresenting } from '../../enums/board-seat-representing.enum';
import { BasicUser } from '../basicUser.model';
import { DateTime } from 'luxon';
import { CONFIG } from '../../../config';
import { DateTimeService } from '../../../core/services';

export class BoardSeat implements BaseEntity {
  id: number;
  company: CompanyBasic;
  companyPosition: string;
  person: Person;
  startDate: DateTime;
  endDate: DateTime;
  representing: BoardSeatRepresenting;
  committees: string;
  resignationSentDate: DateTime;
  contactPerson: string;
  contactEmail: string;
  boardRole: string;
  tradeRestriction: TradeRestriction;
  lastModified: DateTime;
  lastModifiedBy: BasicUser;
  active: boolean;

  constructor(boardSeat: any = {}) {
    this.id = boardSeat.id || null;
    this.company = boardSeat.company || null;
    this.companyPosition = boardSeat.companyPosition || null;
    this.person = boardSeat.person || null;
    this.startDate = typeof boardSeat.startDate === 'string' ?
      DateTimeService.parseDate(boardSeat.startDate, CONFIG.timezoneUTC).setZone('America/New_York')
      : boardSeat.startDate;
    this.endDate = typeof boardSeat.endDate === 'string' ?
      DateTimeService.parseDate(boardSeat.endDate, CONFIG.timezoneUTC).setZone('America/New_York')
      : boardSeat.endDate;
    this.representing = BoardSeatRepresenting[String(boardSeat.representing)] || null;
    this.committees = boardSeat.committees || null;
    this.resignationSentDate = typeof boardSeat.resignationSentDate === 'string' ?
      DateTimeService.parseDate(boardSeat.resignationSentDate, CONFIG.timezoneUTC).setZone('America/New_York')
      : boardSeat.resignationSentDate;
    this.contactPerson = boardSeat.contactPerson || null;
    this.contactEmail = boardSeat.contactEmail || null;
    this.boardRole = boardSeat.boardRole || null;
    this.tradeRestriction = boardSeat.tradeRestriction || null;
    this.lastModified = typeof boardSeat.lastModified === 'string' ?
      DateTimeService.parseDate(boardSeat.lastModified, CONFIG.timezoneUTC).toLocal()
      : boardSeat.lastModified;
    this.lastModifiedBy = boardSeat.lastModifiedBy ? new BasicUser(boardSeat.lastModifiedBy) : null;
    this.active = boardSeat.active !== undefined ? boardSeat.active : false;
  }
}

export class CreateBoardSeat {
  companyId: number;
  personId: number;
  startDate: DateTime;
  endDate: DateTime;
  representing: string;
  committees: string;
  resignationSentDate: DateTime;
  contactPerson: string;
  contactEmail: string;
  boardRole: string;
  tradeRestrictionId: number;

  constructor(boardSeat?: BoardSeat) {
    this.companyId = boardSeat && boardSeat.company ? boardSeat.company.id : null;
    this.personId = boardSeat && boardSeat.person ? boardSeat.person.id : null;
    this.startDate = boardSeat ? boardSeat.startDate : null;
    this.endDate = boardSeat ? boardSeat.endDate : null;
    this.representing = boardSeat ? boardSeat.representing : null;
    this.committees = boardSeat ? boardSeat.committees : null;
    this.resignationSentDate = boardSeat ? boardSeat.resignationSentDate : null;
    this.contactPerson = boardSeat ? boardSeat.contactPerson : null;
    this.contactEmail = boardSeat ? boardSeat.contactEmail : null;
    this.boardRole = boardSeat ? boardSeat.boardRole : null;
    this.tradeRestrictionId = boardSeat && boardSeat.tradeRestriction ? boardSeat.tradeRestriction.id : null;
  }
}
